<template>
  <!-- <CurtainAnimation @curtain-closed="onCurtainClosed" /> -->

  <div :class="{ 'content-hidden': !isCurtainClosed }">
    <Navbar v-if="$route.name !== 'PageNotFound'" />
    <main>
      <router-view />
    </main>
    <Footer v-if="$route.name !== 'PageNotFound'" />
    
    <QuickContactWidget v-if="$route.name !== 'PageNotFound'" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue"
import { useHead } from "@unhead/vue"
import Navbar from "@/components/navigation/Navbar.vue"
import Footer from "@/components/navigation/Footer.vue"
import CurtainAnimation from "@/components/general/CurtainAnimation.vue"
import QuickContactWidget from "@/components/general/QuickContactWidget.vue"
import router from "./router"
import { setMetaData } from "@/utils/functions"
import { useApolloClient } from '@vue/apollo-composable'
import 'animate.css'

const { resolveClient } = useApolloClient()
const ApolloClient = resolveClient()
const isCurtainClosed = ref(false);

function onCurtainClosed() {
  isCurtainClosed.value = true;
}

useHead({
  titleTemplate: (titleChunk) => {
    return titleFormat(titleChunk);
  },
  meta: [
    { name: "description", content: "We're Nologo Studios. We believe in developing and implementing clear strategies for how digital can grow your business and achieve your goals." }
  ],
  title: null,
})

onMounted(() => {
  getMetaData(router.currentRoute.value.path)
})

router.afterEach((to, from) => {
  if (from.path !== to.path) {
    if (!to.path.startsWith('/services/')) {
      getMetaData(to.path)
    }
  }
})

function getMetaData(path: string) {
  setMetaData(path == "/" ? "home" : path, ApolloClient)
}

function titleFormat(titleChunk: any) {
  const isServiceRoute = router.currentRoute.value.path.startsWith('/services/');

  if (isServiceRoute && !titleChunk) {
    return null;
  }

  if (titleChunk) {
    return titleChunk + " | Nologo Studios";
  }

  return "Nologo Studios";
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap.scss";

.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 300,
  'GRAD' 0,
  'opsz' 24;
  transition: font-variation-settings 0.2s ease-in-out;
}

a:hover .material-symbols-outlined,
.material-symbols-outlined:hover {
  font-variation-settings:
  'FILL' 0,
  'wght' 600,
  'GRAD' 0,
  'opsz' 24;
}
</style>